/* eslint-disable */
import ENV from "../utils/env";

export const baseURL = ENV.GQL_URI_BASE;

export const buildOrganisationsBaseUrl = (organisationId: string): string => {
  return `${ENV.USER_METADATA_SERVICE_BASE_URL}/org/organisations/${organisationId}`;
};
